// extracted by mini-css-extract-plugin
module.exports = {"news":"_1ruBKZ5yPOVAR9iVWzPt-V","headline":"YEUWQJR5ErMP_qgpN89S3","articles":"_6Lpz2OPGujYDbBgxe5ARq"};